import React from 'react';
import styles from './stepFormAccordion.module.scss';
import { useEffect, useState } from 'react';
interface StepFormAccordionProps {
  title: string;
  subTitle: string;
  children: React.ReactNode;
  stepAtual: number;
  stepFormulario: number;
}

function StepFormAccordion({ title, subTitle, children, stepAtual, stepFormulario }: Readonly<StepFormAccordionProps>) {
  const [isStepFormAccordionOpen, setIsStepFormAccordionOpen] = useState(stepAtual === stepFormulario);
  const accordionHeaderStyle = isStepFormAccordionOpen ? styles.open : '';

  useEffect(() => {
    setIsStepFormAccordionOpen(stepAtual === stepFormulario);
  }, [stepAtual, stepFormulario]);

  return (
    <div className={`${styles.stepFormAccordion} ${accordionHeaderStyle} `}>
      <button
        className={`${styles.stepFormAccordionTitle} ${stepAtual !== stepFormulario ? styles.notCurrentStep : ''}`}
        onClick={() => stepAtual !== stepFormulario && setIsStepFormAccordionOpen(!isStepFormAccordionOpen)}
        onKeyDown={() => stepAtual !== stepFormulario && setIsStepFormAccordionOpen(!isStepFormAccordionOpen)}
      >
        <div className={styles.stepFormAccordionTitleContainer}>
          <span className={styles.stepFormAccordionTitle}>{title}</span>
          <span className={styles.stepFormAccordionSubtitle}>{subTitle}</span>
        </div>
        {stepAtual !== stepFormulario && (
          <i className={`fas fa-angle-down ${styles.icon} ${isStepFormAccordionOpen ? styles.iconOpen : ''}`} />
        )}
      </button>
      <div
        className={`${styles.stepFormAccordionContent} ${isStepFormAccordionOpen ? styles.openContent : styles.closedContent}`}
      >
        {children}
      </div>
    </div>
  );
}

export default StepFormAccordion;
